import { useDispatch, useSelector } from "react-redux";
import { Table, Button } from 'react-bootstrap';
import { MIN, MAX, FIXED } from '../../../store/actionTypes';
import { seek, saveAutoSave } from '../../../store/actions';
import { logUsage } from '../../../logUsage';
import * as sto from './symbol_table_offsets';

export default function ResultTableOptimize({ onClick }) {
//  console.log('ResultTableOptimize - Mounting...','onClick=',onClick);
  const model_symbol_table = useSelector((state) => state.model.symbol_table);
  const dispatch = useDispatch();

  const onOptimizeSeekMINWeight = (event) => {
//        console.log('ResultTableOptimize.onOptimizeSeekMINWeight','event=',event);
    logUsage('event', 'ResultTableOptimize', { event_label: 'optimize Seek MIN Weight button' });
    dispatch(saveAutoSave());
    dispatch(seek('Weight', MIN));
    onClick(event);
  }

  const onOptimizeSeekMAXCycle_Life = (event) => {
//        console.log('ResultTableOptimize.onOptimizeSeekMAXCycle_Life','event=',event);
    logUsage('event', 'ResultTableOptimize', { event_label: 'optimize Seek MAX Cycle_Life button' });
    dispatch(saveAutoSave());
    dispatch(seek('Cycle_Life', MAX));
    onClick(event);
  }

  const onOptimizeSeekMINRate = (event) => {
//        console.log('ResultTableOptimize.onOptimizeSeekMINRate','event=',event);
    logUsage('event', 'ResultTableOptimize', { event_label: 'optimize Seek MIN Rate button' });
    dispatch(saveAutoSave());
    dispatch(seek('Rate', MIN));
    onClick(event);
  }

  const onOptimizeSeekMAXStroke = (event) => {
//        console.log('ResultTableOptimize.onOptimizeSeekMAXStroke','event=',event);
    logUsage('event', 'ResultTableOptimize', { event_label: 'optimize Seek MAX Stroke button' });
    dispatch(saveAutoSave());
    dispatch(seek('Stroke', MAX));
    onClick(event);
  }

  return (
    <>
      <p>Select a pre-configured Seek optimization:</p>
      <Table borderless="true" size="sm" className="table-secondary">
        <tbody>
          <tr>
            <td width="50%">
              <Button variant="primary" disabled={model_symbol_table[sto.Weight].lmin & FIXED ? true : false} onClick={onOptimizeSeekMINWeight}>Seek MIN Weight</Button>
            </td>
            <td width="50%">
              <Button variant="primary" disabled={model_symbol_table[sto.Cycle_Life].lmin & FIXED ? true : false} onClick={onOptimizeSeekMAXCycle_Life}>Seek MAX Cycle_Life</Button>
            </td>
          </tr>
          <tr>
            <td width="50%">
              <Button variant="primary" disabled={model_symbol_table[sto.Rate].lmin & FIXED ? true : false} onClick={onOptimizeSeekMINRate}>Seek MIN Rate</Button>
            </td>
            <td width="50%">
              <Button variant="primary" disabled={model_symbol_table[sto.Stroke].lmin & FIXED ? true : false} onClick={onOptimizeSeekMAXStroke}>Seek MAX Stroke</Button>
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
}
